import { buildURL, post } from 'Shared/fetch';
import { trackMP } from 'Shared/mp';

import { identifyUser } from '@/helpers';
import checkLocalStorageForODTP from '@/helpers/checkLocalStorageForODTP';
import { setUserData } from '@/redux/slices/user/actions';

export interface PerformLoginArgs {
  email: string;
  password: string;
  odtp?: string | null;
  /** Mixpanel `method` for the login event. */
  trackingMethod?: string;
  dispatch: (action: any) => void;
}

/**
 * Log in and put the user in the store.
 *
 * Shared by the login form and by the login page's automatic bundle-user path, which cannot use
 * the form because it has credentials from the URL rather than from a human. Throws on failure —
 * callers map the status codes, because the page and the modal surface errors differently.
 */
const performLogin = async ({ email, password, odtp = null, trackingMethod = 'login-page', dispatch }: PerformLoginArgs) => {
  const { userAgent } = navigator;
  const odtpParam = odtp ? checkLocalStorageForODTP(odtp) : undefined;

  const { user } = await post(buildURL('/users/login'), {
    email: email.toLowerCase(),
    password,
    userAgent,
    odtp: odtpParam,
  });

  dispatch(setUserData({ ...user, sessionChecked: true }));
  identifyUser(user);
  trackMP('login', { method: trackingMethod });

  try {
    localStorage.setItem('returningUser', 'true');
  } catch (err) {
    console.warn('Local storage is not available.');
    console.error(err);
  }

  return { user, isRealEmail: !!user?.isRealEmail };
};

export default performLogin;
